import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbGreaterThanIcon = () => {
    return (
        <SvgIcon>
            <polygon points="8.5 7.1 9.54 6.06 14.45 10.96 14.45 10.96 15.5 12 9.58 17.94 8.54 16.91 13.41 12.01 8.5 7.1" />
        </SvgIcon>
    );
};
